import getOr from 'lodash/fp/getOr';

export const iosBridge = getOr(false, 'listeningMode.features.iosBridge');
export const nonBlockingHandoffActive = getOr(false, 'register.payment.handoff');
export const nonBlockingHandoffSupported = getOr(false, 'auth.permissions.kiosk.view');
